import { Grid } from '@mui/material';
import React from 'react';
import { WsPagination } from 'wisestep-base';

const PaginationCardLayout = ({
  totalCount,
  size,
  onPageChange,
  pageNumber,
  children,
}: {
  totalCount: number;
  size: number;
  onPageChange: (_, val: number) => void;
  pageNumber: number;
  children: React.ReactNode;
}) => {
  return (
    <Grid display="flex" flexDirection="column" rowGap={2}>
      <WsPagination
        count={Math.ceil(totalCount / size)}
        onChange={onPageChange}
        itemsPerPage={size}
        pageNumber={pageNumber}
        defaultPage={pageNumber + 1}
        isPageCount={true}
        type="Candidates"
        totalCount={totalCount}
      />
      {children}
      <WsPagination
        count={Math.ceil(totalCount / size)}
        onChange={onPageChange}
        itemsPerPage={size}
        pageNumber={pageNumber}
        defaultPage={pageNumber + 1}
        type="Candidates"
        totalCount={totalCount}
      />
    </Grid>
  );
};

export default PaginationCardLayout;
